import React from 'react';

export default function Footer() {
  return (
    <span className="footer">
      Made by{' '}
      <a
        target={'_blank'}
        rel="noreferrer"
        href="https://github.com/sougataghar477/copyEmoteToDiscord"
      >
        {' '}
        Sougata Ghar
      </a>
    </span>
  );
}
